/**
 * @generated SignedSource<<09a8b9b9ff37ab4cbe3d05630ee620b9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentPageQuery$variables = {
  agentSlug: string;
};
export type DirectoryAgentPageQuery$data = {
  readonly landlordDirectoryAgent: {
    readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentPage_agent" | "DirectoryAgentSeoHead_agent">;
  } | null | undefined;
};
export type DirectoryAgentPageQuery = {
  response: DirectoryAgentPageQuery$data;
  variables: DirectoryAgentPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "agentSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redressScheme",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feesIncludeVat",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amountPence",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percent",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sourceUrls",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DirectoryAgentPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryAgent",
        "kind": "LinkedField",
        "name": "landlordDirectoryAgent",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryAgentPage_agent"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DirectoryAgentSeoHead_agent"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DirectoryAgentPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LandlordDirectoryAgent",
        "kind": "LinkedField",
        "name": "landlordDirectoryAgent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "address",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "website",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleMapsUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleRating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleReviewCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotRating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "trustpilotReviewCount",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasClientMoneyProtection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enrichedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAreaReference",
            "kind": "LinkedField",
            "name": "areas",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAgentSources",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "trustpilot",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMoneyProtection",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LandlordDirectoryAgentFees",
            "kind": "LinkedField",
            "name": "fees",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "management",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "rentCollection",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "tenantFind",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "letOnly",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "renewal",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandlordDirectoryAgentFee",
                "kind": "LinkedField",
                "name": "inventory",
                "plural": false,
                "selections": (v6/*:: as any*/),
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "postcode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "85689ee70facc22e4caddf7357740e65",
    "id": null,
    "metadata": {},
    "name": "DirectoryAgentPageQuery",
    "operationKind": "query",
    "text": "query DirectoryAgentPageQuery(\n  $agentSlug: String!\n) {\n  landlordDirectoryAgent(slug: $agentSlug) {\n    ...DirectoryAgentPage_agent\n    ...DirectoryAgentSeoHead_agent\n    id\n  }\n}\n\nfragment DirectoryAgentPage_agent on LandlordDirectoryAgent {\n  id\n  slug\n  name\n  address\n  phone\n  website\n  googleMapsUrl\n  googleRating\n  googleReviewCount\n  trustpilotUrl\n  trustpilotRating\n  trustpilotReviewCount\n  services\n  redressScheme\n  hasClientMoneyProtection\n  enrichedAt\n  areas {\n    slug\n  }\n  sources {\n    trustpilot\n    services\n    redressScheme\n    clientMoneyProtection\n  }\n  ...DirectoryFeeBlock_agent\n}\n\nfragment DirectoryAgentSeoHead_agent on LandlordDirectoryAgent {\n  slug\n  name\n  postcode\n  address\n  phone\n  website\n  googleMapsUrl\n  areas {\n    slug\n  }\n}\n\nfragment DirectoryFeeBlock_agent on LandlordDirectoryAgent {\n  id\n  name\n  slug\n  fees {\n    management {\n      amountPence\n      percent\n      sourceUrls\n    }\n    rentCollection {\n      amountPence\n      percent\n      sourceUrls\n    }\n    tenantFind {\n      amountPence\n      percent\n      sourceUrls\n    }\n    letOnly {\n      amountPence\n      percent\n      sourceUrls\n    }\n    renewal {\n      amountPence\n      percent\n      sourceUrls\n    }\n    inventory {\n      amountPence\n      percent\n      sourceUrls\n    }\n    feesIncludeVat\n  }\n  sources {\n    feesIncludeVat\n  }\n}\n"
  }
};
})();

(node as any).hash = "b720bf9802bbe3e456efb350be12bf3f";

export default node;
